import { ADD_DERMATOLOGIST_LIST } from "./action-type";

export const setLmbc = (payload: any) => {
    return {
        type: ADD_DERMATOLOGIST_LIST,
        payload: [...payload],
    };
};
